function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import compact from 'lodash/compact';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';
import VueI18n from 'vue-i18n';
import defaultConfig from './config';
import utils from './utils';
import defaultComponents from './components';
import { formatRegularNumber, formatRaeNumber } from './numbers';
import filters from './vuex/filters';
import elements from './vuex/elements';
import pagination from './vuex/pagination';
import order from './vuex/order';
import groups from './vuex/groups';
import frequency_groups from './vuex/frequency_groups';
import api from './vuex/api';
import history from './vuex/history';
export var stores = {
  // The selected result type determines the behaviour and values of other modules.
  // That is why the api module should be the first one to be registered in the store.
  api: api,
  filters: filters,
  elements: elements,
  order: order,
  groups: groups,
  frequency_groups: frequency_groups,
  pagination: pagination,
  history: history
};
var gon = window.gon || {};
export default {
  install: function install(Vue, _ref) {
    var store = _ref.store,
        config = _ref.config,
        components = _ref.components,
        csvElementFields = _ref.csvElementFields;
    this.config = utils.mergeConfig(defaultConfig, config);
    this.installVuePlugins(Vue);
    this.installVueFunctions(Vue, csvElementFields);
    this.installComponents(Vue, components);
    this.installStores(store);
  },
  installVuePlugins: function installVuePlugins(Vue) {
    Vue.use(Vuex);
    Vue.use(BootstrapVue);
    Vue.use(VueAnalytics, {
      id: gon.ga,
      disableScriptLoader: true // Script has to be loaded externally always

    });
    Vue.use(VueI18n);
    var locale = gon.i18n.locale || this.config.i18n.locale;
    this.i18n = new VueI18n({
      locale: locale,
      messages: _defineProperty({}, locale, gon.i18n.translations.ncs || this.config.i18n.translations.ncs)
    });
  },
  installVueFunctions: function installVueFunctions(Vue, csvElementFields) {
    // Converts a number to their localized form using rails number configuration.
    // It relies on VueI18n to get the locale and the number configuration.
    // Formatter is created each time, since translations can change dynamically.
    Vue.prototype.$fn = function (number) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          precision = _ref2.precision,
          delimiter = _ref2.delimiter,
          separator = _ref2.separator;

      precision = precision || parseInt(this.$tOr('number.format', 'precision', '2'));
      delimiter = delimiter || this.$tOr('number.format', 'delimiter', '.');
      separator = separator || this.$tOr('number.format', 'separator', ',');
      var locale = this.$i18n.locale;

      if ((locale === 'es' || locale === 'gl') && this.$ncsConfig.i18n.raeNumberFormat) {
        return formatRaeNumber(number, locale, {
          delimiter: delimiter,
          separator: separator,
          precision: precision
        });
      } else {
        return formatRegularNumber(number, locale, {
          delimiter: delimiter,
          separator: separator,
          precision: precision
        });
      }
    }; // Tries to translate 'prefix.key'.
    // If translation is not found returns value.
    // If value is falsy returns key.


    Vue.prototype.$tOr = function (prefix, key, value) {
      return this.$te("".concat(prefix, ".").concat(key)) ? this.$t("".concat(prefix, ".").concat(key)) : value || key;
    }; // Used to locate index of row in the matrix for a given tag.


    Vue.prototype.$ncsTagList = this.config.tags.list; // Returns the translation for the given tag.
    // Translations are generated automatically using tag matrix and the translation of each level.

    Vue.prototype.$tTag = function (tag) {
      var _this = this;

      var tagRow = this.$ncsConfig.tags.matrix[this.$ncsTagList.findIndex(function (t) {
        return t === tag;
      })] || []; // Per each level (column) in the row, translate the element in that level

      var translatedTag = tagRow.map(function (tag, i) {
        var category = _this.$ncsConfig.tags.categories[i];
        return _this.$tOr("tag.".concat(category.split('.').pop()), tag, null);
      });
      return compact(translatedTag).join(', ');
    };

    Vue.prototype.$ncsElementTitle = this.config.format.elementTitle;
    Vue.prototype.$ncsElementClass = this.config.format.elementClass;
    Vue.prototype.$ncsElementContent = this.config.format.elementContent;
    Vue.prototype.$ncsConfig = this.config;
    Vue.prototype.$ncsCsvElementFields = csvElementFields;
  },
  installComponents: function installComponents(Vue, components) {
    if (!components) {
      components = defaultComponents;
    }

    for (var name in components) {
      Vue.component(name, components[name]);
    }
  },
  installStores: function installStores(store) {
    if (!store) {
      store = new Vuex.Store({});
    }

    for (var module in stores) {
      store.registerModule(module, stores[module]);
    }

    for (var _module in stores) {
      store.dispatch("".concat(_module, "/reset"));
    }

    this.store = store;
  },
  utils: utils,
  defaultComponents: defaultComponents,
  defaultConfig: defaultConfig
};